import { useEffect, useMemo, useState } from "react";
import CosmicController from "../controllers/cosmicController";

const useCosmic = (limit = 10) => {
	const [allPosts, setAllPosts] = useState([]);
	const [page, setPage] = useState(1);
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const getPosts = async () => {
			setLoading(true);

			try {
				const response = await CosmicController.getPosts();

				if (!response.success) {
					throw new Error(response.message);
				}

				setAllPosts(response.data || []);
			} catch (error) {
				setError("При подгрузке постов произошла ошибка");
			} finally {
				setLoading(false);
			}
		};

		getPosts();
	}, []);

	const posts = useMemo(
		() => allPosts.slice(0, page * limit),
		[allPosts, page, limit],
	);
	const hasMore = posts.length < allPosts.length;

	const loadMorePosts = () => {
		if (hasMore && !loading) {
			setPage((prevPage) => prevPage + 1);
		}
	};

	return { posts, error, loading, loadMorePosts, hasMore };
};

export default useCosmic;
